import axios from "../axiosInstance";

class PrivateCarService {
  async getPrivateCarByUserId(userId) {
    return axios.get(`users/${userId}/privatecars`);
  }
}

export default new PrivateCarService();
